export default __webpack_public_path__ + "static/media/flowchartbasedgroupbutton@2x.8b985c55.png";